import { Star, Quote } from "lucide-react";
import { useT } from "../../lib/i18n";

export const Testimonials = () => {
    const t = useT();

    const items = [
        {
            quote: t(
                "Same-day installation and the technician walked my parents through every channel. The kind of service big call centres can't match.",
                "ఒకే రోజులో ఇన్‌స్టాలేషన్ చేశారు, టెక్నీషియన్ మా అమ్మానాన్నలకు ప్రతి ఛానెల్ గురించి వివరంగా చెప్పారు. పెద్ద కాల్ సెంటర్లు ఈ సర్వీస్ ఇవ్వలేవు."
            ),
            name: t("Srinivas Reddy", "శ్రీనివాస్ రెడ్డి"),
            location: t("Armoor", "ఆర్మూర్"),
            initials: "SR",
        },
        {
            quote: t(
                "I added a Sun Direct counter to my mobile shop. RVS handled stock, training, and even my first customer activation.",
                "నా మొబైల్ షాప్‌లో సన్ డైరెక్ట్ కౌంటర్‌ను జోడించాను. RVS స్టాక్, శిక్షణ, మొదటి కస్టమర్ యాక్టివేషన్ — అన్నీ చూసుకున్నారు."
            ),
            name: t("Madhavi K.", "మాధవి కె."),
            location: t("Balkonda · Retailer", "బాల్కొండ · రిటైలర్"),
            initials: "MK",
        },
        {
            quote: t(
                "Storm bent my dish — they showed up within hours and realigned everything. Honest pricing, no surprise charges.",
                "తుఫాన్‌లో నా డిష్ వంగిపోయింది — గంటల్లోనే వచ్చి సరిచేశారు. న్యాయమైన ధర, అదనపు ఛార్జీలు లేవు."
            ),
            name: t("Anil Kumar", "అనిల్ కుమార్"),
            location: t("Bheemgal", "భీమ్‌గల్"),
            initials: "AK",
        },
    ];

    return (
        <section className="bg-white border-y border-rvs-navy-10" data-testid="testimonials-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
                <div className="grid md:grid-cols-12 gap-10 items-end">
                    <div className="md:col-span-7">
                        <p className="eyebrow">{t("Customer voices", "కస్టమర్ల మాటలు")}</p>
                        <h2 style={{fontFamily: "'Outfit', sans-serif"}} className="mt-4 text-4xl md:text-5xl font-black tracking-tight text-rvs-navy leading-[1.05]">
                            {t("Trusted across Armoor — one home at a time.", "ఆర్మూర్ అంతటా నమ్మకం — ప్రతి ఇంటి నుండి.")}
                        </h2>
                    </div>
                    <div className="md:col-span-5 flex items-center gap-3">
                        <div className="flex">
                            {[1,2,3,4,5].map(i => (
                                <Star key={i} className="w-5 h-5 fill-rvs-orange text-rvs-orange" />
                            ))}
                        </div>
                        <p className="text-sm text-[#4A5568]">
                            {t("4.9 average rating · 1000+ households", "4.9 సగటు రేటింగ్ · 1000+ గృహాలు")}
                        </p>
                    </div>
                </div>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
                    {items.map((item, i) => (
                        <div
                            key={i}
                            data-testid={`testimonial-${i}`}
                            className="card-default p-7 fade-up flex flex-col"
                            style={{animationDelay: `${i*80}ms`}}
                        >
                            <Quote className="w-7 h-7 text-rvs-orange/40" />
                            <p className="mt-4 text-base text-rvs-navy leading-relaxed flex-1" style={{fontFamily: "'Manrope', 'Noto Sans Telugu', sans-serif"}}>
                                {item.quote}
                            </p>
                            <div className="mt-6 pt-5 border-t border-rvs-navy-10 flex items-center gap-3">
                                <span className="w-10 h-10 rounded-full bg-rvs-navy text-white flex items-center justify-center text-sm font-bold">
                                    {item.initials}
                                </span>
                                <div>
                                    <p className="text-sm font-bold text-rvs-navy" style={{fontFamily: "'Outfit', 'Noto Sans Telugu', sans-serif"}}>{item.name}</p>
                                    <p className="text-xs text-[#4A5568]" style={{fontFamily: "'Manrope', 'Noto Sans Telugu', sans-serif"}}>{item.location}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
